@if (hasInvitation()) {
  <ion-card class="app-background">
    <ion-card-header class="ion-no-padding">
      <ion-item-divider>
        <ion-label class="text-dark-500 text-bold">{{ title() }}</ion-label>
      </ion-item-divider>
    </ion-card-header>

    <ion-card-content class="ion-no-padding">
      @for (installation of data(); track installation.id) {
        <ion-item class="activated ion-item-resize" lines="full">
          <ion-grid class="ion-no-padding">
            <ion-row class="vertical-center ion-no-padding">
              <ion-col size="1" class="ion-no-padding mr--1">
                <ion-icon name="build" class="ion-no-padding-end"></ion-icon>
              </ion-col>
              <ion-col size="7">
                <ion-label>
                  {{ 'invitation_manage' | translate }}
                  {{ installation.owner.firstname }}
                  {{ installation.owner.lastname }}
                </ion-label>
              </ion-col>
              <ion-col size="4" class="ion-text-right">
                <ion-button
                  size="small"
                  type="button"
                  class="mr--1"
                  color="primary"
                  (click)="onAcceptInvitation(installation.id)"
                >
                  <small>{{ 'invitation_btnAccept' | translate }}</small>
                </ion-button>
              </ion-col>
            </ion-row>
          </ion-grid>
        </ion-item>
      }
    </ion-card-content>
  </ion-card>
}
